import { CONTAINER_HEIGHT } from './Constants';

export const helper = {
  getDelta(event) {
    //마우스 휠 움직이는 정도
    if (event.wheelDelta) {
      return event.wheelDelta;
    } else if (event.deltaY) {
      return -event.deltaY;
    } else {
      return -event.detail;
    }
  },
  throttle(method, delay, context) {
    let inThrottle = false;
    return function () {
      if (!inThrottle) {
        inThrottle = true;
        method.apply(context, arguments);
        setTimeout(() => {
          inThrottle = false;
        }, delay);
      }
    };
  },
  debounce(method, delay, context) {
    let inDebounce;
    return function () {
      clearTimeout(method.inDebounce);
      inDebounce = setTimeout(() => {
        method.apply(context, arguments);
      }, delay);
    };
  },
};

export default class ScrollPages {
  static scrollInstance;

  constructor(currentPageNumber, totalPageNumber, pages, type) {
    // console.log(ScrollPages.scrollInstance);
    // console.log('type: ', type);
    if (ScrollPages.scrollInstance) {
      ScrollPages.scrollInstance.currentPageNumber = currentPageNumber;
      ScrollPages.scrollInstance.totalPageNumber = totalPageNumber;
      ScrollPages.scrollInstance.pages = pages;
      ScrollPages.scrollInstance.type = type;
      return ScrollPages.scrollInstance;
    }

    ScrollPages.scrollInstance = this;

    this.currentPageNumber = currentPageNumber;
    this.totalPageNumber = totalPageNumber;
    this.pages = pages;
    this.viewHeight = document.documentElement.clientHeight;
    this.type = type;
    this.handleMouseWheel = helper.throttle(this.mouseScroll, 500, this);
    this.handleResize = helper.debounce(this.resize, 500, this);
  }
  mouseScroll(event) {
    let delta = helper.getDelta(event);
    //delta는 마우스 휠 움직인 정도로 0보다 크면 위로, 적으면 아래로 휠을 움직인 것임.
    if (delta < 0) {
      this.scrollDown();
    } else {
      this.scrollUp();
    }
  }
  scrollDown() {
    let current = Number(sessionStorage.getItem('currentPage'));
    if (current < this.totalPageNumber) {
      this.pages.style.top = -this.viewHeight * current + CONTAINER_HEIGHT * current + 'px';
      sessionStorage.setItem('currentPage', current + 1);
      this.textFadeInOut();
    }
  }
  scrollUp() {
    let current = Number(sessionStorage.getItem('currentPage'));
    if (current > 1) {
      this.pages.style.top = -this.viewHeight * (current - 2) + (current - 2) * CONTAINER_HEIGHT + 'px';
      sessionStorage.setItem('currentPage', current - 1);
      this.textFadeInOut();
    }
  }
  scrollTo(targetPageNumber) {
    while (this.currentPageNumber !== targetPageNumber) {
      if (this.currentPageNumber > targetPageNumber) {
        this.scrollUp();
      } else {
        this.scrollDown();
      }
    }
  }
  createNav() {
    const pageNav = document.createElement('div');
    pageNav.className = 'nav-dot-container';
    this.pages.appendChild(pageNav);
    for (let i = 0; i < this.totalPageNumber; i++) {
      pageNav.innerHTML += '<p class="nav-dot"><span></span></p>';
    }
    const navDots = document.getElementsByClassName('nav-dot');
    this.navDots = Array.prototype.slice.call(navDots);
    this.navDots[0].classList.add('dot-active');
    this.navDots.forEach((e, index) => {
      e.addEventListener(
        'click',
        (event) => {
          this.scrollTo(index + 1);
          this.navDots.forEach((e) => {
            e.classList.remove('dot-active');
          });
          e.classList.add('dot-active');
        },
        { passive: false },
      );
    });
  }
  updateNav() {
    this.navDots.forEach((e) => {
      e.classList.remove('dot-active');
    });
    this.navDots[this.currentPageNumber - 1].classList.add('dot-active');
  }
  resize() {
    this.viewHeight = document.documentElement.clientHeight;
    this.pages.style.height = this.viewHeight + 'px';
    this.pages.style.top = -this.viewHeight * (this.currentPageNumber - 1) + 'px';
  }
  textFadeInOut() {
    const containersDom = document.getElementsByClassName('text-container');
    let textContainers = Array.prototype.slice.call(containersDom);
    textContainers.forEach((e) => {
      e.classList.remove('in-sight');
    });
    let textContainerInSight = textContainers[this.currentPageNumber - 1];
    //textContainerInSight.classList.add('in-sight');
  }
  mobileFooterFixed() {
    let footer = document.getElementById('footer');

    footer.style.position = 'fixed';
    footer.style.bottom = 0;
  }
  mobileFooterStatic() {
    let footer = document.getElementById('footer');

    footer.style.position = 'static';
  }
  init() {
    this.pages.style.height = this.viewHeight + 'px';
    // this.createNav();
    // this.textFadeInOut();
    if (navigator.userAgent.toLowerCase().indexOf('firefox') === -1) {
      document.addEventListener('wheel', this.handleMouseWheel, { passive: false });
    } else {
      document.addEventListener('DOMMouseScroll', this.handleMouseWheel, { passive: false });
    }
    document.addEventListener('touchstart', this.touchStart, { passive: false });
    document.addEventListener('touchend', this.touchEnd, { passive: false });
    document.addEventListener('touchmove', this.eventPreventDefault, { passive: false });
    window.addEventListener('resize', this.handleResize, { passive: false });
  }
  remove() {
    this.pages.style.height = this.viewHeight + 'px';
    if (navigator.userAgent.toLowerCase().indexOf('firefox') === -1) {
      document.removeEventListener('wheel', this.handleMouseWheel, { passive: false });
    } else {
      document.removeEventListener('DOMMouseScroll', this.handleMouseWheel, { passive: false });
    }
    document.removeEventListener('touchstart', this.touchStart, { passive: false });
    document.removeEventListener('touchend', this.touchEnd, { passive: false });
    document.removeEventListener('touchmove', this.eventPreventDefault, { passive: false });
    window.removeEventListener('resize', this.handleResize, { passive: false });
  }
  touchStart = (event) => {
    this.startY = event.touches[0].pageY;
  };
  touchEnd = (event) => {
    let endY = event.changedTouches[0].pageY;
    if (this.startY - endY < 0) {
      this.scrollUp();
    }
    if (this.startY - endY > 0) {
      this.scrollDown();
    }
  };
  eventPreventDefault = (event) => {
    event.preventDefault();
  };
}
